












































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { SubmitArgs as StudentSelectedArgs } from '@/components/student/studentSelectDialog.vue';
import {
  ScheduleCalendarHeaderDate, ScheduleCalendarMode, Schedule, TutorSchedule, ScheduleRequest
} from '@/modules/schedule';
import ScheduleCalendar from '@/components/schedule/scheduleCalendar.vue';
import { FunctionTypes } from '@/enums/functionTypes';
import AvaivaledVue from '@/components/avaivaled.vue';
import { Subject } from '@/models/subject';
import { Person } from '@/models/person';

@Component({
  components: {
    ScheduleCalendar,
  }
})
export default class extends AvaivaledVue {
  private get pageTitle() { return '基本スケジュール'; }
  private get headerIcon() { return this.isLoading ? 'el-icon-loading' : 'far fa-calendar-alt fa-2x'; }
  private get isLoading() { return this.$store.state.schedule.isLoading; }
  private get schedules(): TutorSchedule[] { return this.$store.state.schedule.baseSchedules; }
  private ScheduleCalendarMode = ScheduleCalendarMode;
  private headers: ScheduleCalendarHeaderDate[] = [
    { date: null, weekday: 1 },
    { date: null, weekday: 2 },
    { date: null, weekday: 3 },
    { date: null, weekday: 4 },
    { date: null, weekday: 5 },
    { date: null, weekday: 6 },
    { date: null, weekday: 0 }
  ];


  private studentSelectVisible = false;
  private selectSubjectVisible = false;
  private selectedSubject: Subject = { id: 0, name: '', color: '' };
  private selectedSubjectId = 0;
  private selectedStudents: Person[] = [];
  private addSchedule: Schedule = {
    scheduleId: 0,
    weekday: 0,
    unixtimeDate: null,
    stringStart: '',
    stringEnd: '',
    subjects: [],
    capacity: 0,
    reservers: [],
    memo: '',
  };

  private loadData() {
    this.$store.dispatch('schedule/getBaseSchedules');
  }

  private mounted() {
    this.loadData();
  }

  private deactivated() {
    this.$destroy();
  }

  private created() {
    this.pageBackCheck(FunctionTypes.Reserve);
  }

  private async createOrEditRequest(request: ScheduleRequest) {
    const response = await this.$store.dispatch(
      request.scheduleId ?
      'schedule/editBaseScheduleRequest' :
      'schedule/createBaseScheduleRequest', request);
    if (response && (response.status === 200 || response.status === 201)) {
      const findTutorSchedule = this.schedules.find((value: TutorSchedule) => {
        return request.tutorId === value.tutorId;
      });
      if (findTutorSchedule !== undefined) {
        this.$notify({
          type: 'success',
          title: '基本スケジュール' + (request.scheduleId ? '編集' : '追加') + '完了',
          message:
            `講師「${findTutorSchedule.tutorName}」の基本スケジュールを` +
            (request.scheduleId ? '編集' : '追加') +
            'しました。',
          position: 'bottom-right'
        });
        this.loadData();
      }
    } else {
      this.$notify({
        type: 'error',
        title: '基本スケジュール' + (request.scheduleId ? '編集' : '追加') + '失敗',
        message: response.message,
        position: 'bottom-right'
      });
    }
  }

  private async removeRequest(scheduleId: number) {
    const response = await this.$store.dispatch('schedule/removeBaseScheduleRequest', scheduleId);
    if (!response) { return; }

    const findTutorSchedule = this.schedules.find((value: TutorSchedule) => {
      return value.schedules.find((schedule: Schedule) => {
        return schedule.scheduleId === scheduleId;
      }) !== undefined;
    });
    if (findTutorSchedule) {
      this.$notify({
        type: 'success',
        title: 'スケジュール削除完了',
        message:
          `講師「${findTutorSchedule.tutorName}」のスケジュールを削除しました。`,
        position: 'bottom-right'
      });
      this.loadData();
    }
  }

  private async moveRequest(request: ScheduleRequest) {
    const response = await this.$store.dispatch(
      request.scheduleId ?
      'schedule/editBaseScheduleRequest' :
      'schedule/createBaseScheduleRequest', request);
    if (response && (response.status === 200 || response.status === 201)) {
      const findTutorSchedule = this.schedules.find((value: TutorSchedule) => {
        return request.tutorId === value.tutorId;
      });
      if (findTutorSchedule !== undefined) {
        this.$notify({
          type: 'success',
          title: '基本スケジュール移動完了',
          message:
            `講師「${findTutorSchedule.tutorName}」の基本スケジュールを移動しました。`,
          position: 'bottom-right'
        });
        this.loadData();
      }
    } else {
      this.$notify({
        type: 'error',
        title: '基本スケジュール移動失敗',
        message: response.message,
        position: 'bottom-right'
      });
    }
  }

  private async copyRequest(request: ScheduleRequest) {
    const response = await this.$store.dispatch('schedule/copyBaseScheduleRequest', request);
    if (response && (response.status === 200 || response.status === 201)) {
      const findTutorSchedule = this.schedules.find((value: TutorSchedule) => {
        return request.tutorId === value.tutorId;
      });
      if (findTutorSchedule !== undefined) {
        this.$notify({
          type: 'success',
          title: '基本スケジュールコピー完了',
          message:
            `講師「${findTutorSchedule.tutorName}」の基本スケジュールをコピーしました。`,
          position: 'bottom-right'
        });
        this.loadData();
      }
    } else {
      this.$notify({
        type: 'error',
        title: '基本スケジュールコピー失敗',
        message: response.message,
        position: 'bottom-right'
      });
    }
  }

  private clickAddReserver(scheduleId: number) {
    let findSchedule: Schedule | undefined;
    this.schedules.find((value) => {
      findSchedule = value.schedules.find((value2) => {
        return value2.scheduleId === scheduleId;
      });
      return findSchedule !== undefined;
    });

    if (findSchedule !== undefined) {
      this.addSchedule = findSchedule;
      this.selectedStudents = JSON.parse(JSON.stringify((findSchedule as Schedule).reservers));
      this.selectedSubjectId = this.addSchedule.subjects[0].id;
      if ((findSchedule as Schedule).subjects.length === 1) {
        this.studentSelectVisible = true;
        this.selectedSubject = this.addSchedule.subjects[0];
      } else {
        this.selectSubjectVisible = true;
      }
    }
  }

  private addSubject() {
    this.studentSelectVisible = true;
    this.selectSubjectVisible = false;
  }

  private async onSubmitSelectedStudents(args: StudentSelectedArgs) {
    const before = this.selectedStudents;
    const after = JSON.parse(JSON.stringify(args.selectedStudents));

    const senderStudents: Person[] = [];
    after.forEach((val: Person) => {
      const isNew = before.find((val2: Person) => {
        return val2.id === val.id;
      }) === undefined;
      if (isNew) {
        senderStudents.push(val);
      }
    });

    if (senderStudents.length === 0) {
        this.$alert('生徒の選択がありませんでした', '', {
          type: 'error',
          confirmButtonText: 'OK',
        });
    } else {
      for (const student of senderStudents) {
        const response = await this.$store.dispatch('schedule/addBaseScheduleReserver', {
          baseScheduleId: this.addSchedule.scheduleId,
          subjectId: this.selectedSubjectId,
          studentId: student.id,
        });
        if (response && (response.status === 201 || response.status === 200)) {
          this.$notify({
            type: 'success',
            title: '予約設定',
            message: '基本スケジュールに生徒の予約を行いました',
            position: 'bottom-right'
          });
        } else {
          this.$notify({
            type: 'error',
            title: '予約エラー',
            message: response.message,
            position: 'bottom-right'
          });
        }
      }
      this.$nextTick(() => {
        (this.$refs.scheduleCalendar as any).closeEditModal();
        this.loadData();
      });
    }
  }

  private onCancelSelectedStudents() {
    const a = 1;
  }

  private clickReserverName(reserverId: string, scheduleId: number) {
    this.$confirm('選択した生徒を基本スケジュールから削除します。よろしいですか？', '', {
      confirmButtonText: 'はい',
      cancelButtonText: 'いいえ',
      type: 'warning'
    })
    .then(async () => {

      const response = await this.$store.dispatch('schedule/removeBaseScheduleReserver', {
        baseScheduleId: scheduleId,
        studentId: reserverId,
      }).catch();
      if (response && (response.status === 201 || response.status === 200)) {
        this.$notify({
          type: 'success',
          title: '予約設定',
          message: '基本スケジュールから生徒の予約を削除しました',
          position: 'bottom-right'
        });
        (this.$refs.scheduleCalendar as any).closeEditModal();
        this.loadData();
      } else {
        this.$notify({
          type: 'error',
          title: '予約エラー',
          message: response.message,
          position: 'bottom-right'
        });
      }
    })
    .catch();
  }
}
